import { Table } from "antd";
import { SCROLL } from 'datastake-daf/src/helpers/Table';
import { expandIcon } from "datastake-daf/dist/components";
import { useActive } from "./hook";
import { useSection } from "../hook";
import UserTypeModal from "../../components/UserTypeModal";
import TransferRightsModal from "../../components/TransferRightsModal";
import TablePagination from "../../../../../components/Table/pagination";
import { Animated } from "../../../../Modules/pme/screens/dashboard/widgets/tasks";
import { getLocales } from "../../../../../components/Table/newTable";

export default function Active({
  dataSource: all = [],
  loading = false,
  search = '',
  setSearch = () => { },
  setActiveFilters = () => { },
  setPerPage = () => { },
  total = 0,
  fetchBlocked = () => { },
  perPage = 0,
  columnConfig = {},
  activeFilters = {},
  setMergeSelected: setSelectedKeys = () => { },
  mergeSelected: selectedKeys = [],
  fetchUsers = () => { },
  options: _options,
  countries = [],
  setPage: _setPage = () => { },
  usersFetched,
  applications = []
}) {
  const {
    renderFilters, loadingKeys, toggledKeys, setToggledKeys,
    expandedRows, setExpandedRows, userRoles, t,
    goPrev, goNext, canGoPrev, page, setPage,
    canGoNext, options,
  } = useSection({ total, perPage, countries, _options, _setPage, activeFilters, setActiveFilters, search, setSearch, applications });

  const {
    _dataSource, userTypeUser, headerColumns, transferRightsUser,
    expandedTableColumns, setUserTypeUser, setTransferRightsUser,
  } = useActive({
    usersFetched, search, activeFilters, fetchUsers,
    perPage, setPage, all, userRoles,
    columnConfig, setExpandedRows, setToggledKeys, loadingKeys,
    fetchBlocked, options, t
  });

  return (
    <>
      {renderFilters()}
      <div className="default-padding daf-table-wrapper">
        <Table
          locale={getLocales(t)}
          columns={headerColumns}
          dataSource={_dataSource}
          pagination={{
            pageSize: perPage,
            current: page,
          }}
          loading={loading}
          rowKey="id"
          scroll={{ x: SCROLL.x }}
          rowSelection={{
            hideSelectAll: true,
            selectedRowKeys: selectedKeys,
            onChange: (v) => {
              if (v.length > 3) {
                setSelectedKeys(v.slice(v.length - 3, v.length));
                return;
              }

              setSelectedKeys(v);
            },
          }}
          expandIcon={(props) => expandIcon({
            ...props,
            arrows: true,
            toggledKeys,
            setToggledKeys,
            loadingKeys,
          })}
          expandable={{
            onExpandedRowsChange: (r) => {
              setExpandedRows(r);
            },
            expandedRowKeys: expandedRows,
            rowExpandable: (r) => !!r?.users?.length,
            expandedRowRender: (r) => {
              return (
                <Animated className="overflow-cont" key={r.id} isActive={toggledKeys.includes(r.key)} maxHeight={SCROLL.y}>
                  <Table
                    locale={getLocales(t)}
                    pagination={false}
                    scroll={{ x: SCROLL.x }}
                    className="lv-2-table"
                    columns={expandedTableColumns}
                    dataSource={r.users || []}
                    expandable
                    expandedRowRender={() => null}
                    rowKey="id"
                    expandIcon={() => <button type="button" className="ant-table-row-expand-icon ant-table-row-expand-icon-spaced" aria-label="Expand row"></button>}
                  />
                </Animated>
              )
            }
          }}
          rowClassName={(rec) => expandedRows.includes(rec.key) ? 'expanded' : ''}
        />

        <TablePagination
          t={t}
          onChangePagination={(v) => {
            setPerPage(v);
            setPerPage(v);
            fetchUsers({ perPage: v, page: 1 });
            setPage(1);
          }}
          page={page}
          totalPages={Math.ceil(total / perPage)}
          goPrev={() => {
            goPrev();
            fetchUsers({ page: page - 1 });
          }}
          goNext={() => {
            goNext();
            fetchUsers({ page: page + 1 });
          }}
          canGoNext={canGoNext}
          canGoPrev={canGoPrev}
          loaded
          totalItems={total}
          doTotalItems
          perPage={perPage}
        />
      </div>
      {userTypeUser ? (
        <UserTypeModal
          userType={userTypeUser}
          onClose={() => setUserTypeUser(null)}
          fetchUsers={fetchUsers}
        />
      ) : null}
      <TransferRightsModal
        transferRightsUser={transferRightsUser}
        onClose={() => setTransferRightsUser(null)}
        dataSource={_dataSource}
        fetchUsers={fetchUsers}
      />
    </>
  );
}
